module.exports = __webpack_public_path__ + "media/images/icon_arrow_left_gray-f3f6ed3529d4afcfa01534dc9788be08.png";